import { Component, OnInit, inject } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { CommonModule } from '@angular/common';
import { NewsletterComponent } from '@app/shared/components/newsletter/newsletter.component';
import { FaqsService } from '@app/shared/components/api/services/faqs.service';
import { MessageService } from 'primeng/api';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-faqs',
  imports: [
    AccordionModule,
    CommonModule,
    NewsletterComponent,
    PaginatorControlComponent,
    RouterModule,
  ],
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.scss',
})
export class FaqsComponent implements OnInit {
  [x: string]: any;
  faqs: any;
  loading: boolean = false;
  pagination = new Pagination<any>();

  private readonly messageService = inject(MessageService);
  private readonly faqService = inject(FaqsService);

  ngOnInit(): void {
    this.loadFAQs();
  }

  loadFAQs(): void {
    this.loading = true;
    const params = {
      PageSize: this.pagination.pageSize || 10,
      PageNumber: this.pagination.pageNumber || 1,
      OrderBy: 'id desc',
    };

    this.faqService.list(params).subscribe({
      next: (res) => {
        this.pagination = new Pagination<any>().deserialize(res);

        this.faqs = res?.data.map((f: any) => {
          const [pergunta, resposta] = f.valor.split('|');

          return {
            ...f,
            pergunta,
            resposta,
            open: false,
          };
        });
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Falha',
          detail: err?.error?.message || 'Ocorreu um erro inesperado',
          life: 5000,
        });
      },
    });
  }

  trackByFn(index: number, item: any): any {
    return item.id;
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadFAQs();
  }
}
